export const variables = {
  // Color Variables
  black:                '#000000',
  white:                '#FFFFFF',
  orange:               '#FFA500',

  primary:              '#055FE5',

  dark:                 '#1e1e20',
  darker:               '#161616',
  darkest:              '#111111',

  backdropColor:        '#8e8e8e24',

  // Text Color
  textPrimary:          '#9297a4',
  textSecondary:        '#676a73',
  textHeading:          '#D8FFAD',

  error:                '#F44336',
  warning:              '#f57c00',

  iconColor:            '#ffffff',

  // border Colors
  borderColor:          '#1e1e20',
  divider:              '#1e1e20',

  // Hover Color
  hover:                '#333246',

  // FontSizes Variables
  xxs:                  '0.875em',
  xs:                   '0.9em',
  sm:                   '1em',
  md:                   '1.2em',
  lg:                   '1.4em',
  xl:                   '1.6em',
  xxl:                  '1.8em',

  // Icon FontSize
  sizeLarge:            '2.4rem',
  sizeMedium:           '2rem',
  sizeSmall:            '1.8rem',

}